import type React from 'react'
import { type IResourceComponentsProps } from '@refinedev/core'
import { Edit, useForm } from '@refinedev/antd'
import { Form, Input } from 'antd'

export const ControlEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps/* , queryResult */ } = useForm()

  const instance: string = formProps?.initialValues?.instance

  return (
    <Edit saveButtonProps={saveButtonProps} title={`Invia comando all'istanza ${instance}`}>
      <Form {...formProps} layout='vertical'>

        <Form.Item
          label={'🕹 Command to ' + instance}
          name='command'
          rules={[
            {
              required: true
            }
          ]}
        >
          <Input placeholder='npm run update ; npm install' />
        </Form.Item>

      </Form>
    </Edit>
  )
}
